export interface DataRoomDownload {
	id: number;
	firstName: string;
	lastName: string;
	emailAddress: string;
	organization: string | null;
	downloadType: DocumentDownloadType;
	createdOn: Date;
}

export type DocumentDownloadType = keyof typeof DocumentDownloadTypeMap;
export const DocumentDownloadTypeMap = {
	Direct: 'File Download',
	DownloadFolder: 'Folder Download',
	DownloadAll: 'Download All',
	CustomDownload: 'Custom Download',
};
